import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const ReduceMenstrualWasteOrganicPads = () => {
  useMetaTags({
    title: "Reduce Menstrual Waste with Organic Pads | Eco-Friendly Period Care",
    description: "Switch to biodegradable organic pads and reduce menstrual waste. Discover how organic menstrual products support sustainability and reduce landfill impact.",
    keywords: "reduce menstrual waste, biodegradable pads, eco-friendly period care, organic sanitary pads, sustainable menstrual products, zero-waste period",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/reduce-menstrual-waste-organic-pads",
    ogTitle: "Reduce Menstrual Waste with Organic Pads | Eco-Friendly Period Care",
    ogDescription: "Learn how organic menstrual pads help reduce landfill waste and support an eco-friendly lifestyle. Choose sustainability for a greener planet.",
    ogImage: "https://images.unsplash.com/photo-1706535426949-e90f953f0d6d?w=600",
    ogUrl: "https://organicpads.shop/reduce-menstrual-waste-organic-pads",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Reduce Menstrual Waste with Organic Pads | Eco-Friendly Period Care",
    twitterDescription: "Switch to biodegradable organic pads and minimize menstrual waste. Make a sustainable choice for a healthier planet.",
    twitterImage: "https://images.unsplash.com/photo-1706535426949-e90f953f0d6d?w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/reduce-menstrual-waste-organic-pads"
    },
    "headline": "Reduce Menstrual Waste with Organic Pads | Eco-Friendly Period Care",
    "description": "Switch to biodegradable organic pads and reduce menstrual waste. Discover how organic menstrual products support sustainability and reduce landfill impact.",
    "image": "https://images.unsplash.com/photo-1706535426949-e90f953f0d6d?w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "reduce menstrual waste",
      "biodegradable pads",
      "eco-friendly period care",
      "organic sanitary pads",
      "sustainable menstrual products",
      "zero-waste period"
    ]
  }
  

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        How Organic Pads Help Reduce Menstrual Waste
      </h1>
      <img
        src="https://images.unsplash.com/photo-1706535426949-e90f953f0d6d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjZ8fGNvdHRvbiUyMG5hdHVyYWwlMjBzYW5pdGFyeSUyMHBhZHxlbnwwfHwwfHx8MA%3D%3D"
        alt="Waste Reduction"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        Organic pads represent a significant step forward in reducing menstrual waste. Unlike conventional pads that persist in landfills for centuries, organic options break down naturally, helping to create a more sustainable menstrual care routine.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Environmental Benefits</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Biodegradable materials</li>
        <li>Eco-friendly packaging</li>
        <li>Reduced carbon footprint</li>
        <li>Compostable components</li>
        <li>Less landfill impact</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Minimize Your Impact?</h2>
      <p className="text-gray-700 mb-4">
        Choose <strong>certified biodegradable</strong> products and dispose of them responsibly. Consider complementing organic pads with other reusable menstrual products for maximum waste reduction.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Eco Impact"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Every sustainable choice counts.
        <strong> Start your zero-waste period journey today!</strong>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default ReduceMenstrualWasteOrganicPads;
